import { render, staticRenderFns } from "./AbpayModal.vue?vue&type=template&id=3902bb56&scoped=true&"
import script from "./AbpayModal.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AbpayModal.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./AbpayModal.vue?vue&type=style&index=0&id=3902bb56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3902bb56",
  null
  
)

export default component.exports